import {
  OBSERVATIONS_URL,
  PATIENTS_URL,
  FIRST_OBSERVATION_URL,
  PATIENTS_BY_CENTER_URL,
  DELETE_OR_UPDATE_PATIENT,
  EXPORT_OBSERVATIONS_URL
} from "../resources/ApiUrls";
import MyAxiosInstance from "../utils/MyAxiosInstance";

const getPatients = () => MyAxiosInstance.get(PATIENTS_URL);

const getPatientsByCenter = (centerId) => MyAxiosInstance.get(PATIENTS_BY_CENTER_URL(centerId));

const getObservations = (type, patientId, startDate, endDate, aggregation) =>
  MyAxiosInstance.get(
    OBSERVATIONS_URL(type, patientId, startDate, endDate, aggregation)
  );

const getFirstObservation = (type, patientId) =>
  MyAxiosInstance.get(FIRST_OBSERVATION_URL(type, patientId));

const createPatient = (patientObj) => MyAxiosInstance.post(PATIENTS_URL, patientObj);

const deletePatient = (patientId) => MyAxiosInstance.delete(DELETE_OR_UPDATE_PATIENT(patientId))

const updatePatient = (id, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_UPDATE_PATIENT(id), fieldsToUpdate)

const exportObservations = (type, patientId, startDate, endDate, aggregation) =>
  MyAxiosInstance.get(
    EXPORT_OBSERVATIONS_URL(type, patientId, startDate, endDate, aggregation)
  );
const patientConsts = { getPatients, getObservations, getFirstObservation, getPatientsByCenter, createPatient, deletePatient, updatePatient, exportObservations };

export default patientConsts;
